import { useContext } from 'react'
import { LanguageContext } from '../../i18n'
import type { AccountAdminCopy } from '../../i18n/translations/accountAdminCopy/accountAdminCopy.en'

/** Localized organization admin UI strings (`t.accountAdmin`). */
export function useAccountAdminCopy(): AccountAdminCopy {
  const languageContext = useContext(LanguageContext)
  if (!languageContext) {
    throw new Error('useAccountAdminCopy must be used within LanguageProvider')
  }
  return languageContext.t.accountAdmin
}
